import { Component } from '@angular/core';
import { ProgressComponent } from "../../component/progress/progress.component";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-debug',
  standalone: true,
  imports: [
    ProgressComponent,
    FormsModule
  ],
  templateUrl: './debug.component.html'
})
export class DebugComponent {
  status: string = 'generation_error';
  // status: string = 'awaiting';
  position: number = 0;

  setStatus(status: string) {
    this.status = status;
  }
}
